import _ from 'lodash';

const getBasket = (kg, orderableBaskets) => orderableBaskets.find(b => b.kg === kg);

export function getBaskets(totalWeight, orderableBaskets) {
    const addBasket = (basket, size) => {
        const baskets = [];
        for (let index = 0; index < size; index += 1) {
            baskets.push({
                ...basket,
            });
        }
        return baskets;
    };

    let restWeight = Math.round(totalWeight);
    const baskets = [];

    // baskets of 6kgs
    if (restWeight / 6 >= 1) {
        const weight6kg = Math.floor(restWeight / 6);
        restWeight -= (6 * weight6kg);
        baskets.push(...addBasket(getBasket(6, orderableBaskets), weight6kg));
    }

    // if total weight is not divisiable through 3kgs and bigger than 2kgs
    if (totalWeight % 3 !== 0 && totalWeight > 2) {
        if (restWeight <= 3) {
            // add 1 3kgs basket
            baskets.push(...addBasket(getBasket(3, orderableBaskets), 1));
        } else {
            // add 1 6kgs basket
            baskets.push(...addBasket(getBasket(6, orderableBaskets), 1));
        }
    } else {
        // baskets of 3kgs
        if (restWeight > 0 && restWeight / 3 > 0) {
            const weight3kg = Math.floor(restWeight / 3);
            restWeight -= (3 * weight3kg);
            baskets.push(...addBasket(getBasket(3, orderableBaskets), weight3kg));
        }

        // baskets of 2kgs
        if (restWeight > 0) {
            const weight2kg = Math.floor(restWeight / 2);
            baskets.push(...addBasket(getBasket(2, orderableBaskets), weight2kg));
        }
    }

    return baskets;
}

export function getBasketsPrivate(people, orderableBaskets) {
    /**
     * 1 Person = 2kg Korb
     * 2-3 Personen = 3kg Korb
     * 4-6 Personen = 6kg Korb
     * 7 - 10 Personen = 9kg Korb
     */
    if (people === 1) {
        return [getBasket(2, orderableBaskets)];
    } else if (people >= 2 && people <= 3) {
        return [getBasket(3, orderableBaskets)];
    } else if (people >= 4 && people <= 6) {
        return [getBasket(6, orderableBaskets)];
    }
    return [getBasket(6, orderableBaskets), getBasket(3, orderableBaskets)];
}

export function getKiloPrice(totalWeight, subscriptionTypes, subscriptionType) {
    const type = subscriptionTypes.find(a => a.id === subscriptionType);
    return type.kgPrice * totalWeight * 4; // per month
}

export function getTotalWeightRounded(totalWeight) {
    if (totalWeight < 1.5) {
        return Math.round(2);
    }
    // round(4/3)*3 = 3kg, because we can only ship multiples of 3
    return Math.round(totalWeight / 3) * 3;
}

export function getTotalWeightByPeople(
    appetites,
    appetiteId,
    people,
) {
    const { factor } = appetites.find(a => a.name === appetiteId);
    return people * factor;
}

export function getTotalWeightByPeoplePrivate(baskets) {
    return _.sumBy(_.flatMap(baskets), 'kg');
}

export function getTotalWeightByQuantity(
    appetites,
    appetiteId,
    quantity,
) {
    const totalWeight = quantity.reduce(
        (prev, curr) => prev.amount + curr.amount,
    );
    return Math.round(totalWeight);
}

export function getBowls(dayBaskets) {
    const bowls = [];
    const basketsOf2 = dayBaskets.filter(b => b.kg === 2);
    const basketsOf3 = dayBaskets.filter(b => b.kg === 3);
    const basketsOf6 = dayBaskets.filter(b => b.kg === 6);

    const add = (id, amount) => {
        const bowl = bowls.find(b => b.id === id);
        if (bowl) {
            // if bowl already exists, increase amount
            bowl.amount += amount;
        } else {
            // add new bowl
            bowls.push({ id, amount });
        }
    };

    return bowls;
}

export function getAmounts(totalWeight, deliveryBaskets, subscriptionType, baskets, mode) {
    // quantity distributed by amount of people
    const mondayBasket = baskets.monday.length;
    const wednesdayBasket = baskets.wednesday.length;
    let availableDeliveryDay = subscriptionType && subscriptionType.products[0].delivery_days;
    let amountMonday = 0;
    let amountWednesday = 0;
    if (mode === 'private' && !mondayBasket && wednesdayBasket) {
        availableDeliveryDay = availableDeliveryDay.filter(p => p !== 1);
    } else if (mode === 'private' && !wednesdayBasket && mondayBasket) {
        availableDeliveryDay = availableDeliveryDay.filter(p => p !== 3);
    }
    const mondayAvailable = availableDeliveryDay.some(p => p === 1);
    const wednesdayAvailable = availableDeliveryDay.some(p => p === 3);

    if (totalWeight < 3) {
        amountMonday = mondayAvailable ? 2 : 0;
        amountWednesday = !mondayAvailable && wednesdayAvailable ? 2 : 0;
    } else if (totalWeight === 3) {
        amountMonday = mondayAvailable ? 3 : 0;
        amountWednesday = !mondayAvailable && wednesdayAvailable ? 3 : 0;
    } else if (totalWeight === 6) {
        amountMonday = mondayAvailable ? 6 : 0;
        amountWednesday = !mondayAvailable && wednesdayAvailable ? 6 : 0;
    } else {
        const basketsOf3 = deliveryBaskets.filter(b => b.kg === 3);
        const basketsOf6 = deliveryBaskets.filter(b => b.kg === 6);
        if (mondayAvailable && wednesdayAvailable) {
            amountMonday = ((basketsOf6.length * 6) / 2) + (basketsOf3.length * 3);
            amountWednesday = (totalWeight - amountMonday);
        } else if (!mondayAvailable) {
            amountMonday = 0;
            amountWednesday = totalWeight;
        } else {
            amountMonday = totalWeight;
            amountWednesday = 0;
        }
    }
    return {
        monday: amountMonday,
        wednesday: amountWednesday,
    };
}



// WEBPACK FOOTER //
// ./static/js/Order/calculations.js